import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getContent, getHtmlFromMarkdown, enums } from '../../utils';
import Button from '../base/button';
import { FullScreenLoadingIndicator } from '../base/full-screen-loading-indicator';
import {
  IKenticoData,
  KenticoDataContext,
} from '../../contexts/kentico-data-context';
import Handlebars from 'handlebars';
import { registerSelf } from '../../hooks/use-handlebars/helpers';
import redirectArrow from '../../images/redirect-arrow.svg';

export type ExternalRedirectLocationState = {
  redirectUrl?: string;
};

const getDynamicContent = async (
  setContent: React.Dispatch<React.SetStateAction<string>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  assets: IKenticoData['assets'],
) => {
  const result = await getContent(globalThis.location.pathname, 'page');
  registerSelf(Handlebars, () => '', assets);
  setContent(Handlebars.compile(result)({}));
  setIsLoading(false);
};

const ExternalRedirect: () => React.ReactElement = () => {
  const history = useHistory();
  const { state } = useLocation<ExternalRedirectLocationState>();
  const [content, setContent] = React.useState<string>('');
  const [isLoading, setIsLoading] = React.useState(true);
  const { assets } = React.useContext(KenticoDataContext);

  React.useEffect(() => {
    getDynamicContent(setContent, setIsLoading, assets).catch(() => {
      setIsLoading(false);
    });
  }, [assets]);

  const handleContinue = () => {
    const url = state?.redirectUrl;
    if (url) {
      window.open(url, '_blank');
    }
  };

  if (isLoading) {
    return <FullScreenLoadingIndicator />;
  }

  return (
    <div
      id="external-redirect"
      className="tw-mx-auto tw-max-w-[600px] tw-flex tw-flex-col tw-gap-6"
    >
      <img
        alt=""
        aria-hidden="true"
        src={redirectArrow}
        className="tw-size-40"
      />

      {content && (
        <div
          id="external-redirect-content"
          dangerouslySetInnerHTML={getHtmlFromMarkdown(content)}
        />
      )}

      <div className="tw-flex tw-flex-col tw-gap-6 sm:tw-flex-row">
        <Button
          id="external-redirect-cancel"
          buttonStyle={enums.ButtonTypes.secondary}
          className="tw-w-full"
          onClick={() => history.goBack()}
        >
          Cancel, Go Back
        </Button>
        <Button
          id="external-redirect-continue"
          buttonStyle={enums.ButtonTypes.primary}
          className="tw-w-full"
          onClick={handleContinue}
          disabled={!state?.redirectUrl}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export { ExternalRedirect };
